import React, { useEffect, useState } from "react";

import Modal from "../modal/Modal";

const ConfirmationModal = ({
  show,
  handleClose,
  title,
  description,
  onConfirm,
  showRemarks = false,
  remarksLabel = "Remarks (optional)",
  remarksPlaceholder = "Add a reason or note…",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  loading = false,
}) => {
  const [remarks, setRemarks] = useState("");

  useEffect(() => {
    if (!show) setRemarks("");
  }, [show]);

  const handleConfirm = () => {
    if (showRemarks) {
      onConfirm?.(remarks.trim());
    } else {
      onConfirm?.();
    }
  };

  return (
    <Modal
      bodyStyle={{ borderRadius: "10px" }}
      colWidth={5}
      show={show}
      handleClose={loading ? undefined : handleClose}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "10px",
          marginBottom: "20px",
        }}
        className="modal-header"
      >
        <h5 className="modal-title">{title}</h5>
        <button
          type="button"
          className="btn-close"
          onClick={handleClose}
          disabled={loading}
        ></button>
      </div>
      <div style={{ marginBottom: "10px" }} className="modal-body">
        {description ? <p>{description}</p> : null}
        {showRemarks && (
          <div style={{ marginTop: description ? "12px" : 0 }}>
            <label
              htmlFor="confirmation-remarks"
              style={{ display: "block", marginBottom: "6px", fontWeight: 500 }}
            >
              {remarksLabel}
            </label>
            <textarea
              id="confirmation-remarks"
              className="form-control"
              rows={3}
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              placeholder={remarksPlaceholder}
              disabled={loading}
            />
          </div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "10px",
        }}
        className="modal-footer"
      >
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleClose}
          disabled={loading}
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleConfirm}
          disabled={loading}
        >
          {loading ? "Please wait…" : confirmLabel}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
